import { useShopOrderMilestones } from '../../../api/hooks';
import { MilestoneSummary } from '../../order/MilestoneSummary';

/**
 * Retailer order page — the same milestone figures the admin sees, read from the same derivation.
 * A legacy order shows nothing new. The payment form itself stays in `shop/Order.tsx`; the API
 * refuses a payment for a milestone the order has not reached, and says why.
 */
export function RetailerMilestones({ orderId }: { orderId: string | undefined }) {
  const { data: m } = useShopOrderMilestones(orderId);
  if (!m) return null;
  return <MilestoneSummary milestones={m} quietWhenLegacy />;
}
